import { Select } from 'antd';
import { themesList } from 'constants/themesList';
import styled from 'styled-components';

export const StyledMainDiv = styled.div<{ scheme?: string }>`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  margin-bottom: 14px;
  padding: 16px 18px;
  background: ${({ scheme }) =>
    themesList[scheme as keyof typeof themesList].colorPrimary};
  border: 1px solid #e8e8e8;
  border-radius: 10px;

  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

  &:hover {
    border-color: ${({ scheme }) =>
      themesList[scheme as keyof typeof themesList].colorPrimary};

    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
    transform: translateY(-1px);
  }
`;

export const StyledSpan = styled.span<{ scheme?: string }>`
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.6;
  color: #fff;
  white-space: normal;
  word-break: break-word;
`;

export const StyledSelect = styled(Select)`
  width: 220px;
  flex-shrink: 0;
  margin-right: 8px;

  .ant-select-selector {
    border-radius: 8px !important;
    min-height: 38px !important;
    align-items: center;
  }

  .ant-select-selection-item,
  .ant-select-selection-placeholder {
    line-height: 36px !important;
  }

  .ant-select-dropdown {
    min-width: 600px !important;
    max-width: 600px !important;
    max-height: 300px !important;
    min-height: 100px !important;
  }

  .ant-select-dropdown .rc-virtual-list {
    max-height: 300px !important;
    min-height: 100px !important;
  }

  .ant-select-dropdown .ant-select-item {
    min-height: 50px !important;
    height: auto !important;
    padding: 12px 16px !important;
    white-space: normal !important;
    word-break: break-word !important;
    line-height: 1.5 !important;
    display: flex !important;
    align-items: flex-start !important;
  }

  .ant-select-dropdown .ant-select-item-option-content {
    white-space: normal !important;
    word-break: break-word !important;
    overflow: visible !important;
    width: 100% !important;
  }
`;
